import { PRODUCT_TABLE_TYPES } from '../../../lib/constants';

const tableComponent = PRODUCT_TABLE_TYPES.STANDARD;

const columns = (id) => [
  {
    name: 'Bank',
    elements: [
      {
        type: 'ApplyNow',
        props: {
          logoLink: true,
          impressionId: `logo-${id}`,
        },
      },
      {
        type: 'StarRating',
      },
      {
        type: 'ApplyNow',
        props: {
          impressionId: `cta-${id}`,
        },
      },
    ],
  },
  {
    name: 'APY',
    elements: [
      {
        type: 'EditableQuickFacts',
        props: {
          quickFactName: 'getQuickFactAPY',
        },
      },
    ],
  },
  {
    name: 'Monthly Fee',
    elements: [
      {
        type: 'EditableQuickFacts',
        props: {
          quickFactName: 'getQuickFactMonthlyFee',
        },
      },
    ],
  },
  {
    name: 'Details',
    elements: [
      {
        type: 'ProsAndCons',
      },
    ],
  },
];

export default {
  columns,
  tableComponent,
};
